export const DASHBOARD_MENU = 'DASHBOARD_MENU';
export const SUPERADMIN_MENU = 'SUPERADMIN_MENU';
export const THEME_MENU = 'THEME_MENU';
export const USER_PROFILE_MENU = 'USER_PROFILE_MENU';
export const USER_SUB_MENU = 'USER_SUB_MENU';
export const MY_BOOKING_MENU = 'MY_BOOKING_MENU';
export const BOOKING_FORM = 'BOOKING_FORM';
export const ONBOARD_FORM = 'ONBOARD_FORM';
export const NOTIFICATION_MENU = 'NOTIFICATION_MENU';
